// هوية صاحب السلة/المفضلة: التوكن للمستخدم المسجل، أو guest token ثابت للزائر.
// الباك إند يستخدم المستخدم لو فيه Bearer token، وإلا يرجع لـ X-Guest-Token.

const GUEST_KEY = 'guest_token';
let memoryToken = null;

const generateToken = () =>
  typeof crypto !== 'undefined' && crypto.randomUUID
    ? `g_${crypto.randomUUID()}`
    : `g_${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;

export const getGuestToken = () => {
  try {
    let token = localStorage.getItem(GUEST_KEY);
    if (!token) {
      token = generateToken();
      localStorage.setItem(GUEST_KEY, token);
    }
    return token;
  } catch {
    // التخزين غير متاح: نحتفظ بالتوكن طول ما الصفحة مفتوحة
    memoryToken = memoryToken || generateToken();
    return memoryToken;
  }
};

export const shopperHeaders = (authToken) => ({
  'X-Guest-Token': getGuestToken(),
  ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
});
